<template>
	<div v-if="formData">
		<el-form-item prop="sendCity" label="演出城市限制:"
			:rules="[{ required: formData.sendCityType == 1 ? true : false, message: '请选择发放城市' }]">
			<el-radio-group v-model="formData.sendCityType" @change="changeSendCityType">
				<el-radio :label="0">全国</el-radio>
				<el-radio :label="1">指定城市</el-radio>
			</el-radio-group>
			<el-cascader v-if="formData.sendCityType == 1" v-model="formData.sendCity" :show-all-levels="false"
				:options="cityList" filterable
				:props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, emitPath: false }"
				style="width:100%" ref="cityCascader" placeholder="请选择城市" clearable>
			</el-cascader>
		</el-form-item>
		<el-form-item prop="sendLimit" label="购票演出限制:">
			<el-radio-group v-model="formData.sendLimit" @change="changeSendLimit">
				<el-radio :label="0">不限制</el-radio>
				<el-radio :label="1">限制演出类型</el-radio>
				<el-radio :label="2">限制演出ID</el-radio>
				<el-radio :label="3">限制主办</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item v-if="formData.sendLimit == 1" prop="sendLimitIds" label="限制演出类型:"
			:rules="[{ required: formData.sendLimit == 1 ? true : false, message: '请选择限制演出类型', trigger: 'change' }]">
			<el-cascader v-model="formData.sendLimitIds" :options="showTypeTagList"
				:props="{ multiple: true, value: 'id', label: 'name', children: 'tags', emitPath: false }" clearable
				placeholder="请选择限制演出类型" style="width:100%" ref="cascader">
			</el-cascader>
		</el-form-item>
		<el-form-item v-if="formData.sendLimit == 2" prop="sendLimitIds" label="限制演出:">
			<el-input placeholder="输入需要限制使用的演出ID" v-model.trim="sActivityIds">
				<el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
			</el-input>
			<el-table class="MT10" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading"
				row-key="id">
				<el-table-column prop="id" label="演出ID" width="90"></el-table-column>
				<el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>
				<el-table-column label="限制票品">
					<template slot-scope="scope">
						<el-select v-model="scope.row.ids" placeholder="所有票品可用" multiple clearable>
							<el-option-group v-for="g in scope.row.sessions" :key="g.id" :label="g.name">
								<el-option v-for="item in g.tickets" :key="item.id" :label="`${g.name} - ${item.name}`"
									:value="item.id">
									{{item.name}}
								</el-option>
							</el-option-group>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-form-item>
		<el-form-item prop="sendLimitIds" label="演出发起人:" v-if="formData.sendLimit == 3" >
			<el-select v-model="formData.sendLimitIds" filterable remote placeholder="请输入演出发起人"
				:remote-method="searchStartUser" :loading="userLoading" size="medium">
				<el-option v-for="item in startUserList" :key="item.id"
					:label="`[${$userType.get(item.userType)}]${item.name}`" :value="item.id">
				</el-option>
			</el-select>	
		</el-form-item>
		<el-form-item prop="sendExcludeActivity" v-if="formData.sendLimit == 3">
			<span slot="label">
				<span><el-checkbox v-model="formData.sendExcludeActivity" :true-label="1"
						:false-label="0">定向发放获取演出不可使用</el-checkbox></span>
			</span>
		</el-form-item>
		<el-form-item prop="sendMode" v-if="formData.sendLimit == 3" >
			<span>
				发放方式：<small>
					<span class="color-warning"><span class="el-icon-warning"></span> <template v-if="formData.sendMode == 1">按购买订单发放，仅首次购买发放，只发放一张券，购买订单时发放，无论订单有几张票仅发放一张</template> <template v-if="formData.sendMode == 2">按购买票数发放，购买时订单有几张票就发放几张优惠券</template></span>
				</small>
			</span><br>
			<el-radio-group v-model="formData.sendMode">				
				<el-radio :label="1">按订单购买发放</el-radio>
				<el-radio :label="2">按购买票数发放</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item prop="datetimerange" label="定向发放时间:" :rules="[{ required: true, message: '请选择定向发放时间' }]">
			<el-date-picker v-model="formData.datetimerange" type="datetimerange" start-placeholder="开始时间"
				end-placeholder="结束时间" class="fl" size="medium" :default-time="['00:00:00', '23:59:59']"
				value-format="yyyy-MM-dd HH:mm:ss" unlink-panels>
			</el-date-picker>
		</el-form-item>
	</div>
</template>
<script>
	import {
		fetchAllCity,fetchUser
	} from '@/assets/js/commonApi'
	export default {
		name: 'TargetedSend',
		props: {
			formData: {
				type: Object,
				default: null
			},
			showTypeTagList: {
				type: Array,
				default: () => []
			},
			sendsActivityList: {
				type: Array,
				default: () => []
			},
		},
		data() {
			return {
				cityList: [],
				sActivityIds: "",
				sActivityList: [],
				sActivityLoading: false,
				startUserList: [], //演出发起人集合
				userLoading:false,
			}
		},
		mounted() {
			let _sendCity = this.formData.sendCity
			_sendCity = _sendCity != 0 ? _sendCity.toString() : ''
			this.formData.sendCity = _sendCity ? _sendCity.split(',') : 0;
			this.formData.sendCityType = this.formData.sendCity != 0 ? 1 : 0;

			if (this.formData.sendLimit == 2) {
				this.sActivityIds = this.formData.sendLimitBusinessActivityIds ? this.formData.sendLimitBusinessActivityIds
					.toString() : ''
				this.searchActivity()
			}
			if (this.formData.sendLimit == 3 && this.formData.sendLimitIds) {
			    this.searchUser(this.formData.sendLimitIds, -1, 'startUserList');
			}
			console.log(typeof(this.formData.sendLimitIds))
			this.formData.datetimerange =  this.formData?.sendStartTime && this.formData?.sendEndTime?[this.formData.sendStartTime, this.formData.sendEndTime]: null;
			
			this.getCityList();
		},
		methods: {
			// 演出发起人搜索
			searchStartUser(query) {
				this.searchUser(query, -1, 'startUserList');
			},
			// 搜索用户
			async searchUser(query, userType, obj) {
				if (query !== "") {
					this.userLoading = true;
					const res = await fetchUser({
						queryValue: query,
						userType: userType,
					}).finally(() => {
						this.userLoading = false;
					});
			
					const {
						state,
						result
					} = res.data;
			
					if (state == 1 && result) {
						this[obj] = result;
					}
				}
			},
			//获取城市列表
			async getCityList() {
				const res = await fetchAllCity({}).catch(() => {});
				const {
					state,
					result
				} = res.data;
				if (state == 1) {
					this.cityList = result;
				}
			},
			// 切换发送城市类型
			changeSendCityType() {
				if (this.formData.sendCityType == 1) {
					this.formData.sendCity = [];
				} else {
					this.formData.sendCity = 0;
				}
			},
			// 切换发送限制
			changeSendLimit() {
				this.formData.sendLimitIds = "";
				this.formData.sendExcludeActivity = 0
				this.formData.sendMode = 1
			},
			//删除演出
			delActivity(id) {
				this.sActivityList = this.sActivityList.filter(v => v.id != id);
				this.formData.sendLimitIds = this.sActivityList.map(v => v.id);
			},
			//搜索演出
			async searchActivity() {
				if (this.sActivityIds) {
					this.sActivityLoading = true;

					this.sActivityIds = this.sActivityIds.replace(/，/g, ',');

					let _sActivityIds = this.sActivityIds.split(',');
					_sActivityIds = [...new Set(_sActivityIds.map(v => parseInt(v)))]; // 去重

					const res = await this.$request({
						url: '/activity/activityIdNameList',
						method: 'post',
						data: _sActivityIds
					}).catch(() => {
						return {
							data: {
								state: '0',
								msg: '请求错误'
							}
						};
					}).finally(() => {
						this.sActivityLoading = false;
					});

					const {
						state,
						msg,
						result
					} = res.data;

					if (state != 1) {
						return this.$message.error(msg || '请求失败');

					} else {
						if (result && result.length > 0) {
							const ticketIds = this.formData.sendLimitTpIds ?
								this.formData.sendLimitTpIds.split(',') : [];
							result.forEach(item => {								
								const existingItem = this.sActivityList.find(v => v.id == item.id);
								if (!existingItem) {									
									item.ids = [];									
									if (ticketIds.length > 0) {
										item.sessions.forEach(session => {
											session.tickets.forEach(ticket => {
												if (ticketIds.includes(ticket.id)) {
													if (!item.ids.includes(ticket.id)) {
														item.ids.push(ticket.id);
													}
												}
											});
										});
									}
									this.sActivityList.push(item);
									this.sendsActivityList.push(item);
								}
							});
							this.formData.sendLimitIds = this.sActivityList.map(v => v.id).join(',');							

						} else {
							this.$message.error(msg || '没有找到相关演出');
						}
					}
				}
			},
		}
	}
</script>